module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lightbox', {
    ref: "lightbox",
    attrs: {
      "images": _vm.imagesList,
      "showLightBox": _vm.showLightBox,
      "show-caption": _vm.showCaption
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdabfc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageLightbox/index.vue
// module id = 1810
// module chunks = 1